import React from 'react'

export const Dashboard = React.lazy(() => import('./Dashboard'))
export const Login = React.lazy(() => import('./Login'))